import { render } from "./DesignationsSetting.vue?vue&type=template&id=fdb664a2"
import script from "./DesignationsSetting.vue?vue&type=script&lang=js"
export * from "./DesignationsSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__